import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-records',
    templateUrl: './records.component.html',
    styleUrls: ['./records.component.css']
})
export class RecordsComponent implements OnInit {

    constructor() {
    }

    ngOnInit() {
    }

}



// WEBPACK FOOTER //
// /home/escobar/Documents/Projects/E-VEND/Srl-Evend/FE/superadmin/src/app/records/records.component.ts